import React from 'react';

import TextField from '@material-ui/core/TextField';

import './index.scss';

export default ({className, value, onChange, variant, label, fullWidth, type, name, onEnterKeyPress, ...rest}) => {
    const handleKeyPress = (event) => {
        if(event.key === 'Enter' && onEnterKeyPress){
            onEnterKeyPress()
        }
    }

    return (
        <TextField
            onKeyPress={handleKeyPress}
            className={className + " TextField"}
            value={value}
            onChange={onChange}
            variant={variant || "standard"}
            label={label}
            fullWidth={fullWidth}
            type={type || "text"}
            name={name}
            {...rest}
        />
    )
}
